module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content_pages",
    attrs: {
      "id": "report-metrics"
    }
  }, [_c('div', {
    staticClass: "table_info clearfix"
  }, [_c('div', {
    staticClass: "table_info-col"
  }, [_c('div', {
    staticClass: "table_info-title"
  }, [_vm._v(_vm._s(_vm.$t('report.metrics.total_visits')))]), _vm._v(" "), _c('div', {
    staticClass: "table_info-number"
  }, [_vm._v(_vm._s(_vm.metrics.box_hits))])]), _vm._v(" "), _c('div', {
    staticClass: "table_info-col"
  }, [_c('div', {
    staticClass: "table_info-title"
  }, [_vm._v(_vm._s(_vm.$t('report.metrics.quizzes_completed')))]), _vm._v(" "), _c('div', {
    staticClass: "table_info-number"
  }, [_vm._v(_vm._s(_vm.metrics.completed_submissions_count))])]), _vm._v(" "), _c('div', {
    staticClass: "table_info-col"
  }, [_c('div', {
    staticClass: "table_info-title"
  }, [_vm._v(_vm._s(_vm.$t('report.metrics.completion_rate')))]), _vm._v(" "), _c('div', {
    staticClass: "table_info-number"
  }, [_vm._v(_vm._s(_vm.metrics.conclusion_rate))])]), _vm._v(" "), _c('div', {
    staticClass: "table_info-col"
  }, [_c('div', {
    staticClass: "table_info-title"
  }, [_vm._v(_vm._s(_vm.$t('report.metrics.average_time_to_complete')))]), _vm._v(" "), _c('div', {
    staticClass: "table_info-number"
  }, [_vm._v(_vm._s(_vm.metrics.conclusion_average_time))])])]), _vm._v(" "), _c('ul', {
    staticClass: "table_collumns"
  }, [_c('Device', {
    attrs: {
      "metric": _vm.devicesMetrics('desktop'),
      "banner": "kp-panel-pc",
      "title": _vm.$t('report.metrics.desktop')
    }
  }), _vm._v(" "), _c('Device', {
    attrs: {
      "metric": _vm.devicesMetrics('tablet'),
      "banner": "kp-panel-tablet",
      "title": _vm.$t('report.metrics.tablet')
    }
  }), _vm._v(" "), _c('Device', {
    attrs: {
      "metric": _vm.devicesMetrics('mobile'),
      "banner": "kp-panel-mobile",
      "title": _vm.$t('report.metrics.mobile')
    }
  }), _vm._v(" "), _c('Device', {
    attrs: {
      "metric": _vm.devicesMetrics('others'),
      "banner": "kp-panel-others",
      "title": _vm.$t('report.metrics.others')
    }
  })], 1)])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-82a07fba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/metrics/Metrics.vue
 ** module id = 882
 ** module chunks = 1
 **/